module.exports = __webpack_public_path__ + "img/ai-robot.b92af0f1.png";